/**
 * Modulo Tasks
 * @module abstracts/tasks
 * @namespace Abstracts/Tasks
 */
import TasksCollection from './collections/tasks-collections'
import loadScript from '../../libs/load-scripts'
import Core from '../core'

/**
 * Classe gerenciadoras de tarefas
 *
 * @name Tasks
 * @typedef {Object} Tasks
 * @memberof abstracts/tasks
 */
class Tasks {
    /**
     * Constructor da classe Tasks
     *
     * @return {void}
     */
    constructor () {
        this.TasksCollection = new TasksCollection()
        this.TasksCollection.on('add', this._configEvent, this)

        this._setRequestIdleCallback()
    }

    /**
     * Adiciona uma nova tarefa
     *
     * @TODO Enviar o erro para o validate da model TASK
     * @param {any} param01 - Pode ser um array de entidades ou um evento pré-definido ou um callback ou um script.js
     * @param {any} param02 - Pode ser um array de callback e scripts.js ou um script.js ou um callback
     * @return {void}
     */
    add (...params) {
        try {
            if (!params ||
                (Array.isArray(params) && 
                params.length === 0) ||
                params[0] === false) {
                // Nada foi enviado
                throw new Error('Necessário enviar uma task')
            }

            // console.log(params);
            this.TasksCollection.add(params)

            // Avaliação de tasks cadastradas
            
            // No Post atualmente chega ao máximo de 21 tasks e acaba apenas com 15             
            //  ( PAGE_SCROLLS que são continuas e uma de paywall que não sei porque não é disparada )

            // console.log("TAMANHO TASKS ***************************************")
            // console.log("TAMANHO TASKS", this.TasksCollection.length)
            // console.log("TAMANHO TASKS", this.TasksCollection.toJSON())
            // console.log("TAMANHO TASKS ***************************************")
        } catch (ex) {
            console.error('Tasks', ex)
        }
    }

    /**
     * Adiciona uma lista de tarefas

     * @param {array} config - Um array de tarefas
     * @return {void}
     */
    addList (config) {
        try {
            if (!config || !Array.isArray(config) || config.length === 0) {
                throw new Error('Necessário enviar um array de configs')
            }

            for (const task of config) {
                this.TasksCollection.add(task)
            }
        } catch (ex) {
            console.error('Tasks', ex)
        }
    }

    /**
     * Adiciona uma lista de tarefas
     *
     * @param {array} config - Um array de tarefas
     * @return {Task[]} - Um array de tarefas
     */
    getAll () {
        return this.TasksCollection.toJSON()
    }

    /**
     * Listerner do evento add na collection TaskCollection
     *
     * @param {Task} task - A tarefa é enviado como um callback no método add ou config
     */
    _configEvent (task) {
        const waiting = task.get('waiting')

        if (!waiting) {
            this._executeList(task.get('execute'))
            task.trigger('executed')
            return
        }

        Core.Events.on(waiting, () => {
            this._executeList(task.get('execute'))
            task.trigger('executed')
        })
    }

    /**
     * Executa a lista em ordem quando o evento for disparo
     *
     * @param {array} exArr - Lista de callback ou scripts.js
     */
    async _executeList (exArr = []) {
        try {
            // const Promises = []
            // Aguarda por um momento ocioso para execução de ações

            window.requestIdleCallback(async () => {
                // For syncronous
                for (const action of exArr) {
                    // Action é um callback
                    if (typeof action === 'function') {
                        // Promises.push(
                        // Isolando o contexto da execução
                        (() => {
                            // Isolando os erros da execução
                            try {
                                action()
                                return true
                            } catch (ex) {
                                // console.trace()
                                console.error(ex)
                                // TODO: pensar em usar reject
                                // Problema que travaria o promise.all adiante
                                // Isso seria o comportamento correto
                                return true
                            }
                        })()
                        // )
                        // Action é um script.js
                    } else if (this._isScript(action)) {
                        // Promises.push(loadScript(action))
                        await loadScript(action)
                    }
                }
            })
            // await Promise.all(Promises)
        } catch (ex) {
            console.error('Tasks', ex)
        }
    }

    /**
     * Verifica se é um script.js
     * @TODO Verificar se um script
     *
     * @param {string} script - Lista de callback ou scripts.js
     */
    _isScript (script) {
        return true
    }

    /**
     * Aplica a compatibilidade para o requestIdleCallback
     *
     * @param {string} script - Lista de callback ou scripts.js
     */
    _setRequestIdleCallback () {
        // window.requestIdleCallback = window.requestIdleCallback || function (handler) {
        window.requestIdleCallback = function (handler) {
            const startTime = Date.now()
            return setTimeout(() => {
                handler({
                    didTimeout: false,
                    timeRemaining: () => {
                        return Math.max(0, 50.0 - (Date.now() - startTime))
                    }
                })
            }, 1)
        }
    }
}

window.GPAbstractModules = window.GPAbstractModules || {}
window.GPAbstractModules.Tasks = Tasks

/*
 * Modelo de tarefa

Tasks.add(
    ['core', 'page'],
    [
        "nome-script.js",
        () => {},
        () => {}
    ]
);

Tasks.add(
    Core.Events.PAGE_COMPLETE,
    [
        "nome-script.js",
        () => {},
        () => {}
    ]
});

// Callback
Tasks.add(() => {});

// Script
Tasks.add('script.js');

// Evento , Callback
Tasks.add(Core.Events.PAGE_COMPLETE, () => {});

// Entidades , Callback
Tasks.add(['core', 'page'], () => {});

Se houver 1 parámetro apenas só pode ser uma callback ou uma string com endereço de um JS

Se houverem 2 parámetros entram mais possibilidades
O primeiro parámetro será ou um evento conhecido ou uma lista de entidades
O segundo pode ser um callback ou um script.js caso não seja um array
se for um array cada item pode ser um callback ou um script.js

Se houver apenas 1 paramêtro e for um array com mais

Tasks.config(
    [
        ['core', 'page'],
        [
            "nome-script.js",
            () => {},
            () => {}
        ],
    ],
    [
        Core.Events.PAGE_COMPLETE,
        [
            "nome-script.js",
            () => {},
            () => {}
        ]
    ],
    [
        'script.js',
    ],
    [
        [
            'script.js',
            'script-b.js'
        ]
    ],
    [
        () => {},
    ],
    [
        [
            () => {},
            () => {}
        ]
    ],
    [
        Core.Events.PAGE_COMPLETE,
        () => {}
    ],
    [
        ['core', 'page'],
        () => {}
    ]
)
 */
